import { render, staticRenderFns } from "./myImage.vue?vue&type=template&id=6a342fd8&scoped=true&"
import script from "./myImage.vue?vue&type=script&lang=js&"
export * from "./myImage.vue?vue&type=script&lang=js&"
import style0 from "./myImage.vue?vue&type=style&index=0&id=6a342fd8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a342fd8",
  null
  
)

export default component.exports